<template>
    <div>
        <vue-html2pdf
        :show-layout="false"
        :enable-download="false"
        :preview-modal="false"
        :paginate-elements-by-height="1200"
        :filename= "nomeArquivo"
        :pdf-quality="2"
        :manual-pagination="true"
        pdf-format="a4"
        :pdf-margin="10"
        pdf-orientation="portrait"
        pdf-content-width="800px"
        @beforeDownload="abrirNovaGuia"
        ref="html2Pdf">
        <section slot="pdf-content">
            <div class="container-pdf">
                <div class="header-qma">
                    <div class="header-dados">
                        <div class="left-container">
                          <div style="display: flex; align-items: center; gap: 1rem; width: 100%">
                              <div class="infoLf">Código da Obra: <b class="ml-1 infoLfInput"> {{qmaData.codigoObra}}</b></div>
                            </div>
                            <div style="display: flex; align-items: center; gap: 1rem; width: 100%">
                              <div class="d-flex">
                                  Status:
                              </div>
                              <div style="display: flex;" class="status-pill-wip" :style="{background: status.Cor}">
                                <div class="msgStatus"  :style="{color: status.CorTexto }">{{status.Mensagem}}</div>
                              </div>
                            </div>
                        </div>
                        <div class="rigth-container">
                            <div>Tipo da Obra: <b class="ml-1"> {{qmaData.obraNome}}</b></div>
                            <div>Data da Vistoria: <b class="ml-1"> {{qmaData.dataVistoriaFormatadaNotHour}}</b></div>
                        </div>
                    </div>
                    <div class="header-dados">
                        <div class="left-container">
                          <div class="titulo_setor">INFORMAÇÕES GERAIS</div>

                          <div style="display: flex; align-items: center; gap: 1rem; width: 100%">
                            <div style="width: 100%;">
                              <div class="infoLf">Avaliador</div>
                              <div class="infoLfInput">{{qmaData.nome}}</div>

                              <div class="infoLf">Função</div>
                              <div class="infoLfInput">{{qmaData.funcao}}</div>

                            </div>
                            <div style="width: 100%;">

                              <div class="infoLf">Colaborador</div>
                              <div class="infoLfInput">{{qmaData.nomeColaborador}}</div>

                              <div class="infoLf">Tipo Obra</div>
                              <div class="infoLfInput">{{qmaData.obraNome}}</div>

                              <!-- <div class="infoLf">Supervisor</div>
                              <div class="infoLfInput">{{qmaData.coordenador}}</div> -->

                              <!-- <div class="infoLf">Técnico de seg. Responsável</div>
                              <div class="infoLfInput">{{qmaData.responsavelSegurancaNome == null ? 'N/D' : qmaData.responsavelSegurancaNome}}</div> -->
                            </div>
                          </div>
                        </div>
                    </div>
                </div>

                <div class="img_principais" style="margin-bottom: 1rem;">
                  <div class="img_seg_pri">
                    <div class="container_img_estrutura">
                      <img :class="imagensData.fotoPrincipal != null ? 'img' : 'img_sem_img'" :src="imagensData.fotoPrincipal != null ? 'data:image/jpeg;base64,' + imagensData.fotoPrincipal : semImg">
                    </div>
                    <div class="container_text_principais">
                      <div class="font_imgs_principais">FOTO PRINCIPAL</div>
                    </div>
                  </div>
                  <div class="img_seg_pri">
                    <div class="container_img_estrutura">
                      <img :class="imagensData.fotoOpcional != null ? 'img' : 'img_sem_img'" :src="imagensData.fotoOpcional != null ? 'data:image/jpeg;base64,' + imagensData.fotoOpcional : semImg">
                    </div>
                    <div class="container_text_principais">
                      <div class="font_imgs_principais">FOTO OPCIONAL</div>
                    </div>
                  </div>
                </div>

                <div class="container_atividade_critica" style="margin-top: 1rem;">
                  <div v-for="obj in atividadeCritiaca" style="page-break-inside: avoid;" v-bind:key="obj.Id" class="container_atividade">
                    <div class="containerTitulo">ATIVIDADE CRÍTICA</div>
                    <div class="container_atividade"><i class="fas fa-check" style="color: #2E963D; font-size: 15px; padding: 0.5rem;"></i> {{obj.atividadesCriticas.nome == null ? 'N/D' : obj.atividadesCriticas.nome}} </div>
                  </div>
                </div>

                <div class="img_principais" style="page-break-inside: avoid; margin-bottom: 2rem;">
                  <div class="img_apr_corpo" style="page-break-inside: avoid;">
                    <div class="container_img_estrutura_apr" style="page-break-inside: avoid;">
                      <img :class="imagensData.fotoApr != null ? 'img' : 'img_sem_img_apr'" :src="imagensData.fotoApr != null ? 'data:image/jpeg;base64,' + imagensData.fotoApr : semImg">
                    </div>
                    <div class="container_text_principais">
                      <div class="font_imgs_principais">APR</div>
                    </div>
                  </div>
                  <div class="img_apr_corpo" style="page-break-inside: avoid;">
                    <div class="container_img_estrutura_apr" style="page-break-inside: avoid;">
                      <img :class="imagensData.fotoPt != null ? 'img' : 'img_sem_img_apr'" :src="imagensData.fotoPt != null ? 'data:image/jpeg;base64,' + imagensData.fotoPt : semImg">
                    </div>
                    <div class="container_text_principais">
                      <div class="font_imgs_principais">PT</div>
                    </div>
                  </div>
                  <div class="img_apr_corpo" style="page-break-inside: avoid;">
                    <div class="container_img_estrutura_apr" style="page-break-inside: avoid;">
                      <img :class="imagensData.fotoDds != null ? 'img' : 'img_sem_img_apr'" :src="imagensData.fotoDds != null ? 'data:image/jpeg;base64,' + imagensData.fotoDds : semImg">
                    </div>
                    <div class="container_text_principais">
                      <div class="font_imgs_principais">DDS</div>
                    </div>
                  </div>
                </div>

                <div v-for="obj in equipamentos" v-bind:key="obj.Id" style="page-break-inside: avoid; margin-bottom: 1rem;">
                  <div class="container_equipamento" >
                    <div class="containerTitulo" style="page-break-inside: avoid;">{{ obj.descricaoReduzida }}</div>
                    <div style="display: flex; width: 100%; page-break-inside: avoid">
                      <div class="container_img_equipamento" style="padding: 1rem; page-break-inside: avoid">
                        <img class="img_equipa" :src="obj.fotoPrincipal != null ? 'data:image/jpeg;base64,' + obj.fotoPrincipal : semImg"  style="page-break-inside: avoid;">
                      </div>
                      <div class="container_info_equipamento" style="page-break-inside: avoid">
                        <div class="info">
                          <div>Marca: <b class="ml-1"> {{obj.marca}}</b></div>
                        </div>
                        <div class="info">
                          <div>CA: <b class="ml-1"> {{obj.ca}}</b></div>
                        </div>
                        <div class="info">
                          <div>Modelo: <b class="ml-1"> {{obj.modelo}}</b></div>
                        </div>
                        <div class="info">
                          <div>Série: <b class="ml-1"> {{obj.serie}}</b></div>
                        </div>
                        <div class="info">
                          <div>Lote: <b class="ml-1"> {{obj.lote}}</b></div>
                        </div>
                        <div class="info">
                          <div>Data da Fabricação: <b class="ml-1" v-if="obj.dataFabricacao !== '01/01/0001'"> {{obj.dataFabricacao}}</b></div>
                        </div>
                        <div class="info">
                          <div>Descrição: <b class="ml-1"> {{obj.descricao}}</b></div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="obj.fotos.length > 0" class="galeriaContainer">
                    <div style="margin-top: 0.5rem; font-family: Segoe UI; font-size: 15px; color: #605f5f">Galeria:</div>

                    <div class="img_galeria_container">
                      <div v-for="(foto, index) in obj.fotos"
                          :key="index"
                          class="img_galeria_item">
                        <img :src="foto ? 'data:image/jpeg;base64,' + foto : semImg">
                      </div>
                    </div>
                  </div>

                </div>

                <div style="margin-top: 2rem; page-break-inside: avoid">
                    <h1 class="containerTitulo" style="page-break-inside: avoid; margin-bottom: 1rem;" >ASSINATURA</h1>
                    <div style="display:flex; align-items: center; gap: 2rem; page-break-inside: avoid">
                     <img  style="page-break-inside: avoid;" class="imgAss ml-3 mr-1" :src="'data:image/jpeg;base64,' + imagensData.assinatura ">
                     <div class="testeweee">
                       <p class="infoLfInput">{{qmaData.nome == null ? 'N/D' : qmaData.nome}}</p>
                        <!-- <p class="infoLf">Técnico Segurança do Trabalho</p> -->
                         <p class="infoLf">Avaliador</p>
                        <p class="infoLfInput">Zopone Engenharia</p>
                     </div>
                    </div>
                </div>
              </div>
        </section>
        </vue-html2pdf>
    </div>
</template>

<script>
import pdfSurvey from './pdfSurvey'
export default pdfSurvey
</script>

<style scoped>
.imgAss{
  width: 325px;
  height: 150px;
  object-fit: contain;
}
.testeweee{
 flex-flow: column;
}
.info {
  padding: 0.5rem;
  border-top: 1px solid #e6e6e6;
}
.container_info_equipamento {
  width: 100%;
}
.container_img_equipamento {
  width: 100%;
  border-right: 1px solid #e6e6e6;
  display: flex;
  justify-content: center;
  align-content: center;
}
.container_equipamento {
  border-bottom: 1px solid #e6e6e6;
  page-break-inside: avoid; /* Evita que o bloco seja dividido */
  break-inside: avoid;
  border-left: 1px solid #e6e6e6;
  border-right: 1px solid #e6e6e6;
  width: 100%;
}
.container_atividade {
  color: #605f5f;
  border-bottom: 1px solid #e6e6e6;
  border-left: 1px solid #e6e6e6;
  border-right: 1px solid #e6e6e6;

  font-family: 'Segoe UI';
  font-size: 13px;
  font-weight: bold;
}
.container_atividade_critica {
  width: 100%;
  margin-bottom: 1rem;
}
.containerTitulo,
.container_img_equipamento,
.container_info_equipamento {
  page-break-inside: avoid;
  break-inside: avoid;
}
.container_equipamento:nth-child(n) {
  page-break-before: auto;
}

.container_img_equipamento img,
.container_info_equipamento div {
  page-break-inside: avoid;
  break-inside: avoid;
}
.containerTitulo {
  color: #ffffff;
  font-family: 'Segoe UI';
  padding:  0.3rem 0 0.3rem 0.5rem;
  font-size: 13px;
  font-weight: bold;
  background: #2E963D;
}
.containerTitulo {
  color: #ffffff;
  font-family: 'Segoe UI';
  padding:  0.3rem 0 0.3rem 0.5rem;
  font-size: 13px;
  font-weight: bold;
  background: #2E963D;
}
.img {
  max-width: 60%;
  max-height: 60%;
  width: auto;
  height: auto;
  border-radius: 10px 10px 0px 0px;
  border: transparent;
  object-fit: contain; /* Garante que a imagem não se estique */
}
.img_sem_img {
  max-width: 73%;
  max-height: 73%;
  width: auto;
  height: auto;
}
.img_sem_img_apr {
  max-width: 60%;
  max-height: 60%;
  width: auto;
  height: auto;
}
.img_equipa {
  width: 65%;
  max-width: 100%;
  height: auto;
  border-radius:10px;
  border: transparent;
  object-fit: contain; /* Garante que a imagem não se estique */
}

.container_text_principais {
  display: flex;
  width: 100%;
}
.font_imgs_principais {
  text-align: center;
  background: #2E963D;
  padding: 0.3rem;
  color: #ffffff;
  font-family: 'Segoe UI';
  font-size: 13px;
  font-weight: bold;
  width: 100%;
}

.img_principais {
  display: flex;
  gap: 0.5rem;
  border-radius: 10px 10px 0px 0px;
  justify-content: center;
  align-content: center;
  width: 100%;
}
.img_seg_pri {
  width: 100%;
  height: 350px;
}
.img_apr_corpo {
  width: 100%;
  height: 200px;
}
.img_galeria_container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  width: 100%;
  page-break-inside: avoid; /* Evita quebra no meio da galeria */
}

.img_galeria_item {
  width: calc(23% - 10px);
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #e6e6e6;
  border-radius: 10px;
  overflow: hidden;
  break-inside: avoid;
}

.img_galeria_item img {
  width: 100%;
  height: 100%;
  object-fit: contain; /* Mantém a proporção correta */
}

.galeriaContainer {
  page-break-inside: avoid; /* Mantém título e imagens juntos */
}
.container_img_estrutura {
  border-radius: 10px 10px 0px 0px;
  padding: 0.5rem;
  flex-direction: column;
  border: 1px solid #e6e6e6;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 350px;
}
.container_img_estrutura_apr {
  border-radius: 10px 10px 0px 0px;
  padding: 0.5rem;
  flex-direction: column;
  border: 1px solid #e6e6e6;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 200px;
}
.infoLfInput{
  text-align: left;
  margin-bottom: 0.5rem;
  letter-spacing: 0px;
  color: #605f5f;
  font-family: 'Segoe UI';
  font-size: 13px;
  opacity: 1;
  font-weight: bold;
}
.infoLf{
  margin-bottom: 0px;
  text-align: left;
  letter-spacing: 0px;
  font-family: 'Segoe UI';
  color: #6f6e6f;
  font-size: 13px;
  opacity: 1;
}
.titulo_setor {
  color: rgb(19, 59, 26);
  font-family: 'Segoe UI';
  font-size: 15px;
  font-weight: bold;
}
.msgStatus{
  font-family: 'Segoe UI';
  opacity: 1;
  font-weight: bold;
  height: 100%;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
    .observation{
      margin-left: 1rem;
      display: flex;
      gap: 1rem;
    }
    .description-obs{
      display: flex;
      flex-direction: column;
      padding-right: 1rem;
    }
    .risco-font-observacao{
      color: #9AA2A4;
      font-family: 'Segoe UI';
      font-size: 12px;
      padding: 0 0 0 8px;
      width: 100%;
      display: flex;
    }
  .imgRepCheck{
    width: 12rem;
    height: 15rem;
    border-radius:  5px;
    break-inside: avoid;
  }
  .imgOrientacao{
    width: 12rem;
    height: 8rem;
    border-radius:  5px;
    break-inside: avoid;
  }
    .icone-img {
      border-radius: 10px;
      gap: 3rem;
    }
    .font-bold {
      font-size: 14px;
      font-weight: bold;
      color:#666666;
    }
    .card-apr{
      font-size: 12px;
      font-family: 'Segoe UI';
      border-radius: 8px;
      width: 3rem;
      height: fit-content;
      display: flex;
      justify-content: center;
    }
    .avalue-hist{
      font-size: 12px;
      font-family: 'Segoe UI';
      border-radius: 8px;
      width: 3rem;
      height: fit-content;
      display: flex;
      justify-content: center;
    }
.text-description{
  padding: 14px;
  width: 85%;
}
.avalue-description{
  padding: 1.5rem;
  width: 100%;
}
.titles-substages{
  background-color: #F4F4F4;
  align-items: center;
  display: flex;
  padding: 0 14px;
  font-family: 'Poppins';
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 27px;
}
.title-assessment-left, .list-signatures-left{
    width: 85%;
}
.title-assessment-right{
    display: flex;
    align-items: center;
}
.titles-assessment, .titles-signatures {
    padding: 0 16px;
    align-items: center;
    display: flex;
    background: #2E973D;
    color: #fff;
    font-family: 'Poppins';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 27px;
    width: 100%;
}
.header-dados{
    display: flex;
    gap: 10px;
}
.pivspes{
    display: flex;
    align-items: center;
    gap: 20px;
}
.left-container{
    display: flex;
    width: 100%;
    padding: 10px 15px;
    flex-direction: column;
    align-items: flex-start;
    border-radius: 10px;
    background: #F4F4F4;
    gap: 10px;
}
.rigth-container{
    display: flex;
    width: 100%;
    padding: 10px 15px;
    flex-direction: column;
    align-items: flex-start;
    border-radius: 10px;
    background: #F4F4F4;
    gap: 10px;
}
.itemAvaliacao {
    width: 85%;
    color:#1A1818;
    font-family: 'Poppins';
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    display: flex;
    justify-content: space-between;
    border-right: solid 1px #E1E1E1;
}
.review-content {
  width: 15%;
    display: flex;
    justify-content: center;
    color:#1A1818;
    font-family: 'Poppins';
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 27px;
    }
.header-review{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 15px;
    align-items: center;
    gap: 12px;
    border-radius: 10px;
    background: #F4F4F4;
}
.header-qma{
    gap: 10px;
    display: flex;
    width: 100%;
    flex-direction: column;
}
.title-qma {
    display: flex;
    justify-content: center;
    color:#1A1818;
    text-align: center;
    font-family: 'Poppins';
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 27px;
}
.title-signature {
  font-size: 16px;
  color: #008144;
  font-family: 'Segoe UI';
  font-weight: bold;
  break-inside: avoid;
  break-before: avoid;
}
.revisao{
  color: #008144;
  font-weight: bold;
  font-family: 'Segoe UI';
  font-size: 16px;
}
.title-signature {
  break-inside: avoid;
}
.container-pdf{
  padding: 0 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  border-radius: 10px;
  font-family: 'Segoe UI';
  font-weight: 500;
}
.font{
        color: #FFF;
        font-family:'Segoe UI';
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 27px;
    }
    .status-pill-wip {
    display: flex;
    font-size: 14px !important;
    padding: 1rem;
    width: 14rem;
    height: 30px;
    font-weight: bold;
    font-family: 'Segoe UI';
    justify-content: center;
    padding-left: 10%;
    padding-right: 10%;
    border-radius: 25px;
    align-items: center;
}
.status-pill-aproved {
    display: flex;
    font-size: 14px !important;
    padding: 1rem;
    width: 14rem;
    height: 30px;
    color: #133B1A;
    font-weight: bold;
    font-family: 'Segoe UI';
    justify-content: center;
    padding-left: 10%;
    padding-right: 10%;
    border-radius: 25px;
    align-items: center;
    background: #CBE9CF;
}
.status-pill-waiting {
    display: flex;
    font-size: 14px !important;
    padding: 1rem;
    width: 14rem;
    height: 30px;
    color: #003789;
    font-weight: bold;
    font-family: 'Segoe UI';
    justify-content: center;
    padding-left: 10%;
    padding-right: 10%;
    border-radius: 25px;
    align-items: center;
    background: #D4EEFD;
}
.status-pill-reproved {
    display: flex;
    font-size: 14px !important;
    padding: 1rem;
    width: 14rem;
    height: 30px;
    color: #AB0101;
    font-weight: bold;
    font-family: 'Segoe UI';
    justify-content: center;
    padding-left: 10%;
    padding-right: 10%;
    border-radius: 25px;
    align-items: center;
    background: #FFD9D9;
}

</style>



// WEBPACK FOOTER //
// src/views/private/Survey/components/pdfSurvey/pdfSurvey.vue